<template>
  <el-select
    v-model="localModel"
    v-bind="$attrs"
    v-loading="calculateTags"
    :ref="field.name || 'dropdown'"
    :data-name="field.name"
    plain
    :size="size"
    :multiple="multiple || $attrs.multiple"
    :multiple-limit="multipleLimit || 0"
    :filterable="isFilterable || $attrs.filterable"
    :filter-method="fieldWithLazyOptions ? filterOptions : undefined"
    :required="field.required"
    :readonly="field.readonly || ''"
    :placeholder="
      hidden(field) ? 'Недоступно для редактирования' : field.placeholder || ''
    "
    :default-first-option="defaultFirstOption"
    :disabled="
      disabled(field) || field.disabled || !!hidden(field) || disabledEtc
    "
    no-data-text="Справочник пуст"
    no-match-text="Ничего не найдено"
    :popper-class="`
      popup-select 
      ${$attrs['popper-class'] || ''} 
      ${(field.front_field_type && 'skills-popper') || ''}
    `"
    :value-key="specialField ? 'id' : 'name'"
    class="dropdown-el"
    :class="{
      big: size === 'big',
      medium: size === 'medium',
      small: size === 'small' || (!localModel && size === 'status'),
      tag: size === 'tag',
      status: size === 'status',
      'is-error':
        !!field.error || (simpleErrors && field.required && !localModel),
      'no-label': !!$attrs['no-label'],
      'multi-dropdown':
        (multiple || $attrs.multiple) && Array.isArray(localModel),
      'is-empty': specialField && !localModel.length,
      'el-select--clearable':
        field.cancel_button && field.cancel_button == true,
      clearable: showClearButton,
      'loading-tags': calculateTags,
      'is-readonly': !!field.readonly,
      'no-tags': !!noTags
    }"
    :collapse-tags="isCollapsableTags"
    @change="changeValue"
    @input.native="
      callback && callback.field && !fieldWithLazyOptions
        ? callback.field.input(field, $event.target.value)
        : null
    "
    @clear="changeValue({ id: '', name: '' })"
    @visible-change="visibleChange"
  >
    <template v-if="!Object.keys($slots).length">
      <el-option
        v-tooltip
        v-for="item in optionsData"
        :key="item.id"
        :label="formatHtml(item.name) || ''"
        :value="item"
        :disabled="
          isSelectedOption(item)
            ? item.disabled || false
            : item.disabled ||
              blockedOptionsByOtherField.includes(item.id) ||
              disabledByLimit
        "
        :class="[
          'dropdown-el__option',
          item.sub_text ? 'full-option' : '',
          isSelectedOption(item) ? 'selected-opt' : ''
        ]"
      >
        <span v-if="optionIcon" class="dropdown-el__option-item">
          <span>{{ item.name || '' | format }}</span>
          <Icon
            @click.native.stop="$emit(optionIcon.action, item)"
            :iconName="optionIcon.name"
            :iconColor="optionIcon.color"
          />
        </span>
        <span
          v-else-if="item.name || item.sub_text || defaultLabel"
          :class="[
            'dropdown-el__option-item',
            item.sub_text ? 'full-option__item' : ''
          ]"
        >
          <span :class="item.sub_text ? 'full-option__item__name' : ''">
            {{ item.name || defaultLabel | format }}
          </span>

          <span
            v-if="item.sub_text"
            class="full-option__item__description"
            v-html="formatHtml(item.sub_text) || ''"
          >
          </span>
          <Icon
            v-if="isSelectedOption(item) && !multiple"
            iconName="check-grey"
          />
          <Icon
            v-else-if="isSelectedOption(item) && multiple"
            iconName="checkbox-selected"
          />
          <Icon
            v-else-if="!isSelectedOption(item) && multiple"
            iconName="checkbox-unselected"
          />
        </span>
      </el-option>
    </template>
    <component :is="`style`">
      .popup-select { max-width: {{ maxOptionsWidth }}; }
    </component>
    <i
      v-if="hasLeftIcon"
      slot="prefix"
      :class="[
        model.toLowerCase() == 'career_page'
          ? 'career_page'
          : model.toLowerCase() == 'hh'
          ? 'hh'
          : model.toLowerCase() == 'habr'
          ? 'habr'
          : model.toLowerCase() == 'avito'
          ? 'Avito'
          : model.toLowerCase() == 'superjob'
          ? 'SuperJob'
          : model.toLowerCase() == 'trudvsem'
          ? 'trudvsem'
          : model.toLowerCase() == 'rabotaru'
          ? 'RabotaRu'
          : 'Website',
        'el-input__icon'
      ]"
    >
    </i>
    <i
      v-if="showClearButton"
      @click="changeValue({ id: '', name: '' })"
      :class="[
        'el-input__icon el-icon-close',
        !localModel ? 'el-icon__blocked' : ''
      ]"
      ref="clear_icon"
    ></i>
    <div
      v-if="
        (!!fieldWithCreateButton && visibleOptionBtn && !options.length) ||
        visibleLoadMoreBtn
      "
      class="add-option-btn"
    >
      <span class="add-option-btn__title fw-500 secondary">ДЕЙСТВИЯ</span>
      <span
        v-if="visibleOptionBtn && !!createOptionAccess && !options.length"
        v-loading="loading"
        @click="$emit('add-new-option', field.name)"
        class="blue add-option-btn__action"
      >
        <Icon iconName="Plus-bold" iconColor="#0075DB" />
        {{ createBtnText }}
      </span>
      <span
        v-if="visibleLoadMoreBtn"
        v-loading="loading"
        @click="$emit('load-more', searchString)"
        class="blue add-option-btn__action"
      >
        <Icon iconName="refresh" iconColor="#0075DB" />
        Загрузить еще
      </span>
    </div>
    <div
      v-if="
        visibleOptionBtn &&
        !options.length &&
        !inputTimer &&
        !visibleLoadMoreBtn &&
        !!createOptionAccess
      "
      class="add-option-btn"
      slot="empty"
    >
      <span class="add-option-btn__title fw-500 secondary">ДЕЙСТВИЯ</span>
      <span
        v-loading="loading"
        @click="$emit('add-new-option', field.name)"
        class="blue add-option-btn__action"
      >
        <Icon iconName="Plus-bold" iconColor="#0075DB" />
        {{ createBtnText }}
      </span>
    </div>
  </el-select>
</template>

<script>
import { store } from '@/store';
import { FIELD } from '@/utils/constants';
import { form, mixin } from '@/utils/mixins';
import { Option, Select } from 'element-ui';
import Icon from 'Elements/Icon/Icon';

export default {
  mixins: [form, mixin],
  inheritAttrs: false,
  props: {
    options: {
      type: [Object, Array],
      default: () => []
    },
    hasLeftIcon: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    field: {
      type: Object,
      default: () => ({
        name: '',
        required: false,
        placeholder: '',
        disabled: false
      })
    },
    model: { type: [String, Array, Number], default: '' },
    emitEvent: { type: String, default: 'set-value' },
    callback: {
      type: [Function, Object],
      default: null
    },
    size: {
      type: String,
      default: 'big'
    },
    defaultFirstOption: {
      type: Boolean,
      default: false
    },
    visibleOptionBtn: {
      type: Boolean,
      default: false
    },
    visibleLoadMoreBtn: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    createBtnText: {
      type: String,
      default: 'Создать'
    },
    optionIcon: {
      type: Object,
      default: null
    },
    simpleErrors: {
      type: Boolean, // искусственная подсветка ошибок
      default: false
    },
    clearable: {
      //временная отмашка от форм метаданных
      type: Boolean,
      default: true
    },
    parentenum: {
      type: String,
      default: ''
    },
    defaultLabel: {
      type: String,
      default: ''
    },
    noTags: Boolean,
    blockedOptionsByOtherField: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      elemWidth: 0,
      collapseTags: false,
      calculateTags: false,
      localModel: '',
      maxOptionsWidth: 'auto',
      disabledByLimit: false,
      searchString: '',
      // onceLoaded: false,
      inputTimer: null,
      focused: false,
      hovered: false
    };
  },
  created() {
    setTimeout(() => {
      let input = this.$refs[this.field.name || 'dropdown'].$el;
      input.addEventListener('focusin', () => {
        if (!this.focused) this.focused = true;
      });
      input.addEventListener('focusout', () => {
        if (this.focused) this.focused = false;
      });
      input.addEventListener('mouseenter', () => {
        if (!this.hovered) this.hovered = true;
      });
      input.addEventListener('mouseleave', () => {
        if (this.hovered) this.hovered = false;
      });

      const el = this.$refs[this.field.name]?.$children[1].$el;

      if (el) el.addEventListener('keydown', e => e.preventDefault());
    }, 0);
  },
  mounted() {
    if (this.$attrs['arrow-multiselect-focus'] && this.field.multiple) {
      this.$refs[this.field.name].$el.querySelector(
        '.el-input input'
      ).readOnly = false;
    }

    if (this.defaultValue) {
      this.localModel = this.defaultValue;
      if (!this.model) this.changeValue(this.optionsData[0]);
    }

    if (this.$listeners['set-hidden']) {
      this.$emit('set-hidden', this.field.name, false);
    }

    // задаем максимальную ширину списков опций
    const dropdownEl = this.$refs[this.field.name];
    this.maxOptionsWidth = dropdownEl
      ? dropdownEl.$el.offsetWidth + 'px'
      : 'auto';
  },
  computed: {
    isCollapsableTags() {
      return this.localModel?.length > 2 || false;
    },
    showClearButton() {
      return (
        this.clearable &&
        this.localModel !== '' &&
        !this.field.readonly &&
        !(this.field.isMultiSelect || this.field.multiple)
      );
    },
    defaultValue() {
      const isMultipleValue = this.multiple || this.$attrs.multiple;
      const defaultValue =
        !this.model && this.optionsData.some(opt => opt.id === this.model)
          ? this.optionsData.find(opt => opt.id === this.model)
          : this.defaultFirstOption && !this.model
          ? this.optionsData[0]
          : Array.isArray(this.model)
          ? this.optionsData.filter(opt => this.model.includes(opt.id))
          : this.model
          ? this.optionsData.find(opt =>
              this.field.id_name?.value && this.model == this.field.value
                ? opt.id == this.field.id_name.value
                : (this.specialField ? opt.id : this.formatHtml(opt.name)) ==
                  this.model
            )
          : undefined;

      if (
        isMultipleValue &&
        !Array.isArray(defaultValue) &&
        defaultValue !== undefined
      ) {
        return !defaultValue || defaultValue?.id === '' ? [] : [defaultValue];
      } else {
        return defaultValue || '';
      }
    },
    optionsData: function () {
      if (
        this.field.type == 'relate' &&
        store.state.common.newOptions &&
        store.state.common.newOptions[this.field.name] &&
        !store.state.common.newOptions[this.field.name].length &&
        !this.options.length
      ) {
        return [];
      } else {
        if (Array.isArray(this.options)) {
          if (this.dynamicEnumField(this.field)) {
            return !this.parentenum
              ? []
              : this.options.filter(item =>
                  item.id && item.id.split('_')[0] == this.parentenum
                    ? item
                    : null
                );
          } else {
            return this.options.length &&
              (this.options.length == 1
                ? this.options[0].id !== '' && this.options[0].name !== ''
                : true)
              ? this.options || []
              : this.field.visual_value &&
                typeof this.field.value == 'string' &&
                this.model == this.field.value &&
                !Array.isArray(this.field.visual_value)
              ? this.field.visibility !== 'disabled' &&
                this.field.visual_value.id !== '' &&
                this.field.visual_value.name !== ''
                ? []
                : [this.field.visual_value]
              : [];
          }
        } else {
          if (this.dynamicEnumField(this.field)) {
            return !this.parentenum
              ? []
              : Object.keys(this.options).filter(key =>
                  key && key.split('_')[0] == this.parentenum
                    ? {
                        id: key,
                        name: this.options[key]
                      }
                    : null
                );
          } else {
            return Object.keys(this.options).map(key => ({
              id: key,
              name: this.options[key]
            }));
          }
        }
      }
    },
    isFilterable() {
      return (
        this.field.type === FIELD.TYPE.MULTIENUM ||
        this.fieldWithLazyOptions ||
        this.field.name == FIELD.ID.TRUDVSEM_PROFESSION ||
        this.field.name == FIELD.ID.TRUDVSEM_SPECIALTY_EDUCATION ||
        this.field.name == FIELD.ID.PROFESSIONAL_ROLE
      );
    },
    specialField() {
      return (
        this.selectType(this.field.type) &&
        (this.multiple ||
          this.field.type === FIELD.TYPE.CURRENCY_ID ||
          this.field.type === FIELD.TYPE.ENUM ||
          this.field.name == FIELD.ID.REJECTION_REASON)
      );
    },
    multiple() {
      return this.field.isMultiSelect || this.field.multiple;
    },
    multipleLimit() {
      return this.field['multiple-limit'] || this.$attrs['multiple-limit'];
    },
    fieldWithLazyOptions() {
      return (
        this.field.type === FIELD.TYPE.RELLINK ||
        this.field.type === FIELD.TYPE.RELATE ||
        this.field.subtype == FIELD.TYPE.RELLINK
      );
    },
    fieldWithCreateButton() {
      return (
        this.field.front_field_type ||
        this.field.quick_create ||
        this.field.answers_collection ||
        this.fieldWithLazyOptions
      );
    },
    config() {
      return store.state.common.config || {};
    },
    createOptionAccess() {
      return this.config.createOptionAccess &&
        this.config.createOptionAccess.hasOwnProperty(this.field.name)
        ? !!this.config.createOptionAccess[this.field.name]
        : true;
    },
    disabledEtc() {
      // разные причины блокировки
      return store.state.edit.isResetAddress && this.field.name == 'work_place';
    }
  },
  methods: {
    clear() {
      if (this.localModel && !this.disabled(this.field)) {
        this.localModel = '';
        this.$emit(
          this.emitEvent,
          this.field.name,
          Array.isArray(this.model) ? [] : '' /*  || this.localModel */,
          this.field.blocked,
          true // для параметра trigger и вызова метода очистки по self_clean
        );
        if (this.field.id_name?.name) {
          this.$emit(this.emitEvent, this.field.id_name.name, '');
        }
      }
    },
    changeValue: function (opt) {
      const val = !Array.isArray(opt)
        ? this.specialField
          ? opt?.id || ''
          : opt?.name || ''
        : opt.map(o => o.id);

      this.$emit(
        this.emitEvent,
        this.field.name,
        val /*  || this.localModel */,
        this.field.blocked,
        true // для параметра trigger и вызова метода очистки по self_clean
      );

      if (this.callback) {
        if (this.callback && this.callback.field) {
          this.callback.field.change(
            this.field,
            val /* || this.localModel */,
            this.field.blocked
          );
        } else {
          this.callback(val /*  || this.localModel */);
        }
      }

      const { id_name, name, type } = this.field;
      if (
        !this.multiple &&
        type !== FIELD.TYPE.CURRENCY_ID &&
        type !== FIELD.TYPE.ENUM &&
        type !== FIELD.TYPE.DYNAMICENUM
      ) {
        this.$emit('change-option', name, id_name, opt);
      }

      if (this.field.rellink_child && type === FIELD.TYPE.RELLINK) {
        this.$emit(
          'change-rellink-option',
          name,
          this.field.rellink_child,
          opt
        );
      }

      if (this.multipleLimit) {
        this.disabledByLimit = this.localModel.length == this.multipleLimit;
      }
    },
    visibleChange(visible) {
      if (!visible && this.fieldWithCreateButton && this.callback) {
        this.callback.field?.visibleChange
          ? this.callback.field.visibleChange(this.field, visible)
          : this.callback.field;
        this.$nextTick(() => this.$refs[this.field.name].blur());
      }
      this.searchString = '';
      if (
        (this.field.type === FIELD.TYPE.RELLINK ||
          this.remote ||
          this.field.name == 'telegramTemplate' ||
          this.field.subtype === FIELD.TYPE.RELLINK ||
          this.field.type === FIELD.TYPE.RELATE) &&
        visible
      ) {
        this.$emit('filter-option', this.searchString);
      }
    },
    filterOptions(filterValue) {
      this.searchString = filterValue;
      this.inputPause();
    },
    inputPause() {
      if (this.inputTimer != null) clearTimeout(this.inputTimer);

      this.inputTimer = setTimeout(async () => {
        if (!this.disabledByLimit)
          await this.$emit(
            'filter-option',
            this.searchString,
            this.callback?.field?.input && !!this.createOptionAccess
              ? this.callback.field.input(
                  this.field,
                  this.searchString,
                  this.createOptionAccess
                )
              : null
          );
        this.inputTimer = null;
      }, 1000);
    },
    isSelectedOption(item) {
      return !this.multiple
        ? this.localModel.id === item.id
        : Array.isArray(this.localModel) &&
            this.localModel.some(({ id }) => id === item.id);
    }
  },
  watch: {
    model: function () {
      this.localModel = this.defaultValue || '';
    },
    defaultValue: function () {
      if (this.field.name == FIELD.ID.TRUDVSEM_SUBWAYS) {
        // только для поля трудвсем метро
        this.localModel = this.defaultValue || '';
      }
    },
    visibleOptionBtn: function () {
      if (this.visibleOptionBtn) {
        const timer = setInterval(() => {
          const elSelect = $('.add-option-btn').closest(
            '.el-scrollbar.is-empty'
          );
          if (elSelect?.length > 1) return;
          if (elSelect.length) {
            elSelect.show(); // переопределяем библиотечные стили
            // перемещаем элемент с удалением во избежание дублирования:
            elSelect.closest('.el-select-dropdown').append(elSelect.remove());
            clearInterval(timer);
          }
        }, 100);

        setTimeout(() => clearInterval(timer), 1000);
      }
    },
    parentenum: function () {
      if (this.dynamicEnumField(this.field)) {
        this.changeValue({ id: '', name: '' });
        this.localModel = '';
      }
    },
    showClearButton: function () {
      if (this.showClearButton) {
        setTimeout(() => {
          let input = this.$refs[this.field.name || 'dropdown'].$el;
          let clearIcon = this.$refs['clear_icon'];
          let suffixArea = input?.getElementsByClassName(
            'el-input__suffix-inner'
          )[0];
          if (clearIcon) suffixArea?.append(clearIcon);
        }, 0);
      }
    }
  },
  destroyed() {
    if (this.$listeners['set-hidden']) {
      this.$emit('set-hidden', this.field.name, true);
    }
  },
  components: {
    'el-select': Select,
    'el-option': Option,
    Icon
  }
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;

  &.clearable {
    & ::v-deep .el-input__suffix-inner {
      flex-direction: row-reverse;
    }
  }

  & ::v-deep .el-input__suffix-inner {
    .el-icon-arrow-up {
      display: block;
    }
  }

  & ::v-deep .el-input.is-focus > .el-input__inner {
    border: 2px solid $blue80 !important;
  }

  &.loading-tags {
    & ::v-deep .el-tag {
      visibility: hidden;
    }
  }

  &--clearable {
    & ::v-deep .el-input__suffix {
      width: 50px;

      .el-input__suffix-inner {
        display: flex;
        height: 100%;
        flex-direction: row-reverse;
        align-items: center;

        .el-icon-arrow-up {
          display: block !important;
        }

        .el-icon-circle-close {
          content: url('/style/img/cross-small.svg') !important;
          width: 16px;
          height: 16px;
          pointer-events: all;
        }
      }
    }
  }

  & ::v-deep .el-select__caret.is-reverse {
    transform: rotateZ(180deg);
  }

  & ::v-deep .el-select__caret {
    transform: rotateZ(0deg);
  }

  & ::v-deep .el-input__inner {
    border-radius: 4px;
    font-size: 16px;
    color: $black-190;
    font-family: 'Roboto', sans-serif;
  }

  & ::v-deep .el-input__prefix {
    left: 0 !important;

    .el-input__icon:before {
      content: '';
      width: 24px;
      height: 24px;
      display: inline-block;
      background-size: 20px 20px;
      background-repeat: no-repeat;
      background-position: center center;
      position: absolute;
      top: 50%;
      left: 12px;
      margin-top: -12px;
    }

    .hh:before {
      background-image: url('/style/img/hh.svg');
    }

    .career_page:before {
      background-image: url('/style/img/career.png');
    }

    .habr:before {
      background-image: url('/style/img/habr.svg');
    }

    .Avito:before {
      background-image: url('/style/img/Avito.svg');
    }

    .trudvsem:before {
      background-image: url('/style/img/trudvsem.svg');
    }

    .SuperJob:before {
      background-image: url('/style/img/SuperJob.svg');
    }

    .RabotaRu:before {
      background-image: url('/style/img/rabota_ru.svg');
    }

    .widget:before {
      background-image: url('/style/img/widget.svg');
    }
  }

  & ::v-deep .el-icon-arrow-up {
    content: url('/style/img/big-arrow-down.svg');
  }

  & .el-input__icon.el-icon-close {
    content: url('/style/img/cross-small.svg');
    width: 16px;
    height: 16px;
    pointer-events: all;
  }

  & ::v-deep .el-input__icon {
    line-height: 20px;
    padding-bottom: 0;
  }

  & ::v-deep &__input {
    border: none;
    background-color: inherit;
  }

  &.small:not(.multi-dropdown) ::v-deep .el-input,
  &.small:not(.multi-dropdown) ::v-deep .el-input__inner {
    height: 24px;
    line-height: 24px;
  }

  &.tag:not(.multi-dropdown) ::v-deep .el-input,
  &.tag:not(.multi-dropdown) ::v-deep .el-input__inner {
    height: 20px;

    line-height: 20px;
    border: none !important;
    background: $blue40;
    border-radius: 4px;
    color: $white !important;

    &:hover {
      background: $blue40 !important;
    }
  }

  &.tag {
    &::v-deep .el-input__inner {
      padding: 0 26px 0 6px !important;
      border: none !important;
      width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      white-space: normal;
    }

    &::v-deep .el-input__suffix {
      right: 6px;
      .el-input__suffix-inner {
        .el-select__caret {
          transform: unset;
          padding: 2px 0;
          width: 16px;
          margin-left: 4px;
          content: url('/style/img/pencil.svg');
        }
      }
    }
  }

  &.status:not(.multi-dropdown):not(.small) ::v-deep .el-input,
  &.status:not(.multi-dropdown):not(.small) ::v-deep .el-input__inner {
    height: 24px;
    width: 120px;

    line-height: 20px;
    border: none !important;
    background: $blue40;
    border-radius: 4px;
    color: $white !important;

    &:hover {
      background: $blue40 !important;
    }
  }

  &.status:not(.multi-dropdown) ::v-deep .el-input__inner {
    width: 120px;
    padding: 2px 28px 2px 8px !important;
  }

  &.status:not(.multi-dropdown) ::v-deep .el-input {
    width: 120px;
  }

  &.status:not(.small) {
    &::v-deep .el-input__inner {
      padding: 2 28px 2 8px !important;
      border: none !important;
      width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      white-space: normal;
    }

    &::v-deep .el-input__suffix {
      .el-input__suffix-inner {
        .el-select__caret {
          color: white;
          padding: 2px 0;
          filter: $whitePicture;
        }
      }
    }
  }

  &.medium:not(.multi-dropdown) ::v-deep .el-input,
  &.medium:not(.multi-dropdown) ::v-deep .el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  &.big:not(.multi-dropdown) ::v-deep .el-input,
  &.big:not(.multi-dropdown) ::v-deep .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  &:not(.multi-dropdown):hover ::v-deep .el-input__inner {
    background: $black-10 !important;
  }

  &.multi-dropdown ::v-deep .el-select__input {
    margin-left: 4px !important;
  }

  &.multi-dropdown.is-empty ::v-deep .el-select__input {
    margin-left: 12px !important;
  }
}

.full-option {
  height: 60px;
  padding: 8px 16px;

  &__item {
    display: flex;
    flex-direction: column;
    align-items: start;

    &__description {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: $black-100;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }

    &__name {
      line-height: 24px;
    }
  }
}

.el-select-dropdown.el-popper {
  font-family: Roboto, sans-serif;

  .full-option {
    height: 60px;
    padding: 8px 16px !important;

    &:hover {
      background-color: $blue-10;
    }
  }

  & ::v-deep .popper__arrow {
    display: none;
  }
}

.status {
  width: 120px;
}

.dropdown-el__option {
  font-family: 'Roboto', sans-serif;

  .full-option__item {
    display: flex;
    flex-direction: column;
    align-items: start;

    // &__description {
    //   font-weight: 400;
    //   font-size: 14px;
    //   line-height: 20px;
    //   color: $black-100;
    // }

    // &__name {
    //   line-height: 24px;
    // }
  }

  &-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    span {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    svg {
      min-width: 24px;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }

  &.is-disabled {
    color: $grey12 !important;
    cursor: not-allowed;

    &:hover {
      background-color: unset;
    }

    & ::v-deep span {
      pointer-events: none;
    }
  }
}

.is-readonly,
.is-readonly * {
  pointer-events: none !important;
}

.dropdown-el.no-tags .el-select__tags > span {
  .el-tag {
    display: none !important;
  }
}
</style>

<style lang="scss">
.dropdown-el {
  width: 100%;

  .el-select__tags {
    // padding-left: 4px;
    pointer-events: none;

    & > span {
      .el-tag {
        display: flex;
        gap: 4px;
        background: $blue40;
        box-sizing: border-box;
        border-radius: 4px;
        right: 0;

        &:first-child {
          margin-left: 10px;
        }

        .el-icon-close {
          display: none;
          content: url('../../../assets/img/close.svg') !important;
          right: 0;
          transform: scale(0.625);
          width: 16px;
          height: 16px;
        }

        &__close {
          background-color: transparent;
          color: $black-80;

          &:hover {
            background-color: transparent;
            color: $black-90;
          }
        }

        .el-select__tags-text {
          color: $white;
          font-weight: normal;
          font-size: 16px;
          line-height: 20px;
          font-family: 'Roboto Medium', sans-serif;
          max-width: 101px;
        }

        &:hover {
          background: $black-20;
          border: 1px solid transparent;

          &__close {
            background-color: transparent;
            color: $black-80;
          }

          .el-select__tags-text {
            color: $black-80;
          }
        }

        &:disabled {
          background: $black-20;
          border: 1px solid #dadfe4;

          &__close {
            background-color: transparent;
            color: $black-50;
          }

          .el-select__tags-text {
            color: $black-50;
          }
        }
      }
    }

    & + .el-input > .el-input__inner {
      color: transparent !important;
    }
  }
}

.add-option-btn {
  &__title {
    display: block;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 8px 16px;
  }

  &__action {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 18px;
    padding: 2px 16px;
    cursor: pointer;

    svg {
      margin-right: 4px;
    }
  }
}

.skills-popper .el-scrollbar__wrap {
  overflow: auto;
  margin: 0 !important;
}
</style>
